import Reveal from "./Reveal";

export const SectionHeading = ({ eyebrow, title, lead, align = "left" }) => (
    <div
        className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}
    >
        {eyebrow && (
            <Reveal>
                <p className="eyebrow mb-5">{eyebrow}</p>
            </Reveal>
        )}
        <Reveal delay={0.08}>
            <h2 className="font-serif font-medium text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.15] text-white">
                {title}
            </h2>
        </Reveal>
        {lead && (
            <Reveal delay={0.16}>
                <p className="mt-6 text-base lg:text-lg leading-relaxed text-zinc-400">
                    {lead}
                </p>
            </Reveal>
        )}
    </div>
);

export default SectionHeading;
